import { Box, IconButton, Typography } from "@mui/material";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import "./Header.css";
const Header = ({
  background,
  color,
  hideArrow,
  isSticky,
  heading,
  showShareDownloadIcon,
  handleOnClickBackButton,
}) => {
  return (
    <Box
      className="header-container"
      sx={{
        background: background ? background : "#fff",
        color: color ? color : "000",
        position: isSticky ? "sticky" : "static",
        zIndex: isSticky ? 99 : 0,
      }}
    >
      <Box
        className="hide-arrow-container"
        sx={{
          justifyContent:
            hideArrow && !showShareDownloadIcon ? "center" : "space-between",
        }}
      >
        {!hideArrow && (
          <Box className="icon-button-container">
            <IconButton onClick={handleOnClickBackButton}>
              <KeyboardBackspaceRoundedIcon
                className="key-board-backspace-icon"
                style={{ color: color ? color : "#fff" }}
              />
            </IconButton>
          </Box>
        )}
        <Typography
          className="orf-heading-text"
          sx={{
            color: color ? color : "#fff",
            marginLeft: showShareDownloadIcon ? "16px" : "0px",
          }}
        >
          {heading}
        </Typography>
        {!hideArrow && <Box className="hide-arrow-icon"></Box>}
        {showShareDownloadIcon && (
          <Box className="icon-outer-box">
            <IconButton className="share-icon">
              <ShareOutlinedIcon
                style={{ color: color ? color : "#fff" }}
                onClick={() => {
                  // sendShareFileEvent()
                }}
              />
            </IconButton>
            <IconButton className="file-download-icon">
              <FileDownloadOutlinedIcon
                style={{ color: color ? color : "#fff", fontSize: "1.8rem" }}
                onClick={() => {
                  // sendDownloadFileEvent()
                }}
              />
            </IconButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default Header;
